import { Component, Inject, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';
import { ToastrService } from 'ngx-toastr';
import { AppSettings } from 'src/app/core/common/app-settings';
import { OperacionEnum } from 'src/app/core/enums/operacion.enum';
import { GrupoService } from 'src/app/core/services/caso/grupo.service';
import { NotificacionService } from 'src/app/core/services/caso/notificacion.service';
import { SocioService } from 'src/app/core/services/caso/socio.service';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { GrupoVo } from 'src/app/shared/models/caso/grupo/grupo-vo.model';
import { NotificacionDto } from 'src/app/shared/models/caso/notificacion/notificacion-dto.model';
import { NotificacionVo } from 'src/app/shared/models/caso/notificacion/notificacion-vo.model';
import { SocioVo } from 'src/app/shared/models/caso/socio/socio-vo.model';
import { formatDate } from '@angular/common';
import { DatePipe } from '@angular/common';
import { format } from 'date-fns';

@Component({
  selector: 'vex-notificacion-form',
  templateUrl: './notificacion-form.component.html',
  styleUrls: ['./notificacion-form.component.scss']
})
export class NotificacionFormComponent implements OnInit {

  appSettings = AppSettings;
  form: FormGroup;
  notificacionService = inject(NotificacionService);
  grupoService = inject(GrupoService);
  socioService = inject(SocioService);
  public operation: OperacionEnum;
  dto: NotificacionDto = new NotificacionDto();
  vo: NotificacionVo;
  grupos: GrupoVo[];
  socios: SocioVo[];
  tiposNotificacion: string[] = ['EMAIL', 'SMS', 'WHATSAPP', 'PUSH'];
  isGroup: boolean = true;
  datepipe: DatePipe;

  hours: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
  shours: string[] = ["00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"];
  tiposEnvio: string[] = ['AHORA', 'DESPUES'];
  showDespuesEnvio: boolean = false;
  selectedOption = 'AHORA';

  constructor(private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    private toastrService: ToastrService) {
    this.operation = data.operation;
    this.vo = data.entity;
    this.form = this.fb.group({
      titulo: ['', Validators.required],
      cuerpo: ['', Validators.required],
      tipoEnvio: ['', Validators.required],
      fechaEnvio: [new Date(), Validators.required],
      //horaEnvio: ['', Validators.pattern(/^(?:[01][0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$/)],
      despues: [''],
      idGrupo: [''],
      idSocio: [''],
      tipoNotificacion: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.grupoService.findAll().subscribe(result => { this.grupos = result.data });
    this.socioService.findAll().subscribe(result => { this.socios = result.data });
    if (this.operation === OperacionEnum.update) {
      //console.log(this.vo);
      // this.form.controls['razonSocial'].setValue(this.vo.razonSocial);
      // this.form.controls['contacto'].setValue(this.vo.contacto);
      // this.form.controls['documento'].setValue(this.vo.documento);
      // this.form.controls['complemento'].setValue(this.vo.complemento);
      // this.form.controls['email'].setValue(this.vo.email);
      // this.form.controls['celular'].setValue(this.vo.celular);
      // this.form.controls['hasWhatsapp'].setValue(this.vo.hasWhatsapp);
    }
  }

  radioChange(data: MatRadioChange) {
    if (data.value === '1') {
      this.isGroup = true;
    } else {
      this.isGroup = false;
    }
  }

  save() {

    const formattedDate: string = format(this.form.value.fechaEnvio, 'yyyy-MM-dd');
    //console.log(formattedDate);
    this.dto.titulo = this.form.value.titulo;
    this.dto.cuerpo = this.form.value.cuerpo;
    this.dto.idGrupo = this.form.value.idGrupo;
    this.dto.idSocio = this.form.value.idSocio;
    this.dto.tipoNotificacion = this.form.value.tipoNotificacion;
    this.dto.isGroup = this.isGroup;
    this.dto.tipoEnvio = this.form.value.tipoEnvio;
    if (this.dto.tipoEnvio === 'DESPUES') {
      //this.dto.fechaEnvio = this.datepipe.transform(this.form.value.fechaEnvio, 'dd/MM/yyyy');//this.form.value.fechaEnvio;
      //this.dto.horaEnvio = this.form.value.horaEnvio;
      this.dto.despues = formattedDate + ' ' + this.form.value.despues;
    }

    switch (this.operation) {
      case OperacionEnum.create:
        this.notificacionService.persist(this.dto).subscribe(
          (result) => {
            if (result.status) {
              this.toastrService.success(result.message);
              this.dialogRef.close(true);
            } else {
              this.toastrService.warning(result.message);
            }
          },
          (error) => {
            this.toastrService.error(error.message);
          }
        );
        break;
    }
  }

  onChangeTipoEnvio(tipoEnvio: String) {
    if (tipoEnvio === "AHORA") {
      this.showDespuesEnvio = false;
      /*this.form = this.fb.group({
        titulo: ['', Validators.required],
        cuerpo: ['', Validators.required],
        tipoEnvio: ['', Validators.required],
        fechaEnvio: [''],
        horaEnvio: [''],
        idGrupo: [''],
        idSocio: [''],
        tipoNotificacion: ['', Validators.required]
      });*/
    } else {
      this.showDespuesEnvio = true;
      /*this.form = this.fb.group({
        titulo: ['', Validators.required],
        cuerpo: ['', Validators.required],
        tipoEnvio: ['', Validators.required],
        fechaEnvio: ['', Validators.required],
        horaEnvio: ['', Validators.required],
        idGrupo: [''],
        idSocio: [''],
        tipoNotificacion: ['', Validators.required]
      });*/
    }
      
  }

}
